import { useState, useRef, useCallback } from "react";

export default function BeforeAfterSlider({ beforeImage, afterImage, beforeLabel = "Before", afterLabel = "After" }) {
  const [sliderPosition, setSliderPosition] = useState(50);
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  const handleMove = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setSliderPosition(percentage);
  }, []);

  const handleMouseDown = () => { isDragging.current = true; };
  const handleMouseUp = () => { isDragging.current = false; };
  const handleMouseMove = (e) => { if (isDragging.current) handleMove(e.clientX); };
  const handleTouchMove = (e) => { handleMove(e.touches[0].clientX); };

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="before-after-container relative w-full aspect-[16/10] select-none"
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleMouseUp}
      onClick={(e) => handleMove(e.clientX)}
    >
      {/* After Image (full width background) */}
      <img
        src={afterImage}
        alt={afterLabel}
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Before Image (clipped) */}
      <div
        className="before-image-wrapper"
        style={{ width: `${sliderPosition}%` }}
      >
        <img
          src={beforeImage}
          alt={beforeLabel}
          className="w-full h-full object-cover"
          style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%", maxWidth: "none" }}
        />
      </div>

      {/* Slider Handle */}
      <div className="slider-handle" style={{ left: `${sliderPosition}%`, transform: "translateX(-50%)" }} />

      {/* Labels */}
      <div className="absolute top-4 left-4 bg-[#0D2D54]/80 text-white text-xs uppercase tracking-[0.15em] px-3 py-1.5 font-medium">
        {beforeLabel}
      </div>
      <div className="absolute top-4 right-4 bg-[#758C7B] text-[#0D2D54] text-xs uppercase tracking-[0.15em] px-3 py-1.5 font-semibold">
        {afterLabel}
      </div>
    </div>
  );
}
